import { useEffect, useState } from 'react'

const MOBILE_MEDIA_BREAK_POINT = 768
export enum FORM_PRODUCT {
  NATIVE_APP = 0,
  WEB_MOBILE = 1,
  WEB_DESKTOP = 2
}
export const useDimention: () => { isMobile: boolean; fromProduct: number } = () => {
  const [isMobile, setMobile] = useState<boolean>(false)
  useEffect(() => {
    const handleResizeComponent = () => {
      if (isMobile) {
        if (window.innerWidth > MOBILE_MEDIA_BREAK_POINT) {
          setMobile(false)
        }
      } else {
        if (window.innerWidth <= MOBILE_MEDIA_BREAK_POINT) {
          setMobile(true)
        }
      }
    }
    handleResizeComponent()
    window.addEventListener('resize', handleResizeComponent)
    return () => {
      window.removeEventListener('resize', handleResizeComponent)
    }
  }, [isMobile])
  return {
    isMobile: isMobile,
    fromProduct: isMobile ? FORM_PRODUCT.WEB_MOBILE : FORM_PRODUCT.WEB_DESKTOP
  }
}
